module.exports = __webpack_public_path__ + "static/media/MOFOI_LOGO.d99a429d.png";